




























import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "BaseConfirmWithAvatar",
  components: { BaseConfirm, BaseAvatar },
  props: {
    value: { type: Boolean, required: true },
    title: { type: String },
    scrollable: { type: Boolean, default: false },
    users: { type: Array as () => UserPublicData[], required: true },
    alignCenter: { type: Boolean, default: false },
  },
  model: {
    event: "input",
    prop: "value",
  },
});
